const hasSlider = document.querySelector('.js-reviews-slider__slider .swiper');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation }]) => {
			const swiper = new Swiper('.js-reviews-slider__slider .swiper', {
				slidesPerView: 'auto',
				navigation: {
					prevEl: '.js-reviews-slider__slider-arrow-left',
					nextEl: '.js-reviews-slider__slider-arrow-right',
				},
				modules: [Navigation],
			});
		})
		.catch((err) => console.error(err));
}
